import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=62cddf7a&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=62cddf7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cddf7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cddf7a')) {
      api.createRecord('62cddf7a', component.options)
    } else {
      api.reload('62cddf7a', component.options)
    }
    module.hot.accept("./ProductItem.vue?vue&type=template&id=62cddf7a&scoped=true", function () {
      api.rerender('62cddf7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductItem.vue"
export default component.exports